import Icon from '@ant-design/icons';

const NdeNeutralSvg = () => (
  <svg width="1.1em" height="1.1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" fill="currentColor">
    <g>
      <path d="M601.2,598.8c-1.7-1.7-41.4-40.6-127-60.1c4-6.7,7.4-13.9,9.9-21.3h5.9c19.3,0,35-15.7,35-35s-15.7-35-35-35V465
		c9.7,0,17.5,7.8,17.5,17.5S499.7,500,490,500h-1.6c0.9-5.7,1.6-11.5,1.6-17.5h-17.5c0,57.9-54.9,105-122.5,105
		s-122.5-47.1-122.5-105H210c0,6,0.7,11.8,1.6,17.5H210c-9.7,0-17.5-7.8-17.5-17.5S200.4,465,210,465v-17.5c-19.3,0-35,15.7-35,35
		s15.7,35,35,35h5.9c2.5,7.4,5.9,14.5,9.9,21.3c-85.6,19.5-125.2,58.3-127,60.1l12.4,12.4c0.4-0.4,40-39,125.7-56.8
		C262.3,585,303.5,605,350,605s87.7-20,113.2-50.7c85.2,17.8,125.3,56.5,125.7,56.9L601.2,598.8z"/>
      <path d="M323.8,447.5v35c0,14.5,11.8,26.2,26.2,26.2c14.5,0,26.3-11.8,26.3-26.2v-35h-17.5v35c0,4.8-3.9,8.8-8.8,8.8
		c-4.8,0-8.7-3.9-8.7-8.8v-35H323.8z"/>
      <path d="M306.2,535h87.5v17.5h-87.5V535z"/>
      <path d="M288.8,443.1c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S288.8,435.9,288.8,443.1"/>
      <path d="M437.5,443.1c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S437.5,435.9,437.5,443.1"/>
      <path d="M269.4,340.2c0,9.3-7.6,16.8-16.8,16.8s-16.8-7.6-16.8-16.8s7.6-16.8,16.8-16.8S269.4,331,269.4,340.2"/>
      <path d="M366.8,340.2c0,9.3-7.6,16.8-16.8,16.8s-16.8-7.6-16.8-16.8s7.6-16.8,16.8-16.8S366.8,331,366.8,340.2"/>
      <path d="M464.1,340.2c0,9.3-7.6,16.8-16.8,16.8s-16.8-7.6-16.8-16.8s7.6-16.8,16.8-16.8S464.1,331,464.1,340.2"/>
    </g>
  </svg>
);

export const NdeNeutralIcon = props => <Icon component={NdeNeutralSvg} {...props} />;
